<template>
  <div class="">
    
      <div class="grid-containerRC mt-0 mb-5">
<!--        <div class="item1RC">
          Header
        </div>
-->
        <div class="item2RC">          
          <v-tabs
            v-model="tab"
            color="#313b43"
            left
            height="30px"
            optional="true"
            cols="5" md="1" class="ml-0 blue-grey lighten-5">
            <v-tab class="opensansbold size8" v-on:click="switchRegionCity('R')">Regions</v-tab>
            <v-tab class="opensansbold size8" v-on:click="switchRegionCity('C')">
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">FUAs and Cities</span>
              </template>
                <span classe="opensanslight">Indicators under this tab refer to functional urban areas (FUAs). <br>
                FUAs are cities of at least 50,000 inhabitants considered together with their surrounding commuting zones.
                </span>
              </v-tooltip>  
            </v-tab>
          </v-tabs>
        </div>
        <div class="item5RC">
          <!-- Item3 -->
          <!--Breadcrumb/-->
        </div>  
        <div class="item4RC">
          <UnitSelector @changeUnit="chgUnit" :levelChanged="levelChg" :filterChg="filterChg" :countryChanged="countryChg" :show="showUn"/>
        </div>
        <div>
        </div>
      </div>

    </div>    
</template>

<script>
import UnitSelector from '@/components/UnitSelector.vue'
//import Breadcrumb from '@/components/Breadcrumb'

  export default {
    name: 'RegionCityTab',
    watch: {
      '$store.getters.TL': function () {
        let tl = this.$store.getters.TL
        if (tl === 'TL2' || tl === 'TL3') {
          this.tab = 0
        } else {
          this.tab = 1
        }
      }

    },
/*     watch: {
      '$route' (to) {
        this.show = to.name != "Home"
      },
    },   
    data () {
      let show = true
        return {
          show
        }    
    }, */
    components: {UnitSelector},
    props: {filterChg:Boolean},
    methods: {
      chgUnit: function () {
        this.unitChg = !this.unitChg
      },
      switchRegionCity: function (type) {
        // console.log(type)
        let tl = 'TL2'
        if (type == 'R'){
          tl = 'TL2'
          }
        if (type == 'C'){
          tl = 'FUA'
          }

        let name = this.$router.currentRoute.name
        let params = this.$route.params
        let query = this.$route.query
        // console.log(params)
        params.tl = tl
        params.year = 'x'
        params.tu = 'x'
        params.c = 'x'
        params.indicod = 'x'
        name = 'Home'
        this.$router.replace({ name: name, params: params, query: query})
        return true
      },
    },
     data () {
      return {
        unitChg: false,
        switch1: false,
        levelChg: false,
        showUn: false,
        countryChg: false,
        tab: 1
      }
    }
  }
</script>


<style scoped>

.item1RC { grid-area: header; }
.item2RC { grid-area: menu; }
.item3RC { grid-area: main; }
.item4RC { grid-area: right; }
.item5RC { grid-area: footer; }


.grid-containerRC {
  display: grid;
  grid-template-columns: 30%  30% ;
  grid-template-areas:
    'header header header header header header'
    'menu main main main right right'
    'footer footer footer footer footer footer';
  grid-gap: 1px;
  background-color: rgb(255, 255, 255);
  padding: 0px;
}

.grid-containerRC > div {
  background-color: rgba(255, 255, 255, 1.0);
  text-align: center;
  padding: 0px 0;
  font-size: 20px;
}


</style>
